import { IHeavyDutyMachinery } from '../interfaces/heavyDutyMachinery/IHeavyDutyMachinery';
import { isPublicMachineryTelemetry } from '../interfaces/heavyDutyMachinery/ITelemetry';
import { IMapPin } from '../components/SpacesMap';

// Extracted from SpacesMap's own former priceOf/priceLabelOf/liveStatusOf --
// that component is now generic over IMapPin (any category can supply one),
// so deriving a Machinery's own price/live-status label is this file's job,
// not SpacesMap's.
const priceOf = (space: IHeavyDutyMachinery): number => space.pricePerHour ?? space.pricePerNight ?? space.pricePerDayPass ?? 0;

// Available renders identically to "no status at all" (see SpacesMap's own
// buildPricePill) -- only Rented/Maintenance get a visually distinct ring.
const liveStatusOf = (space: IHeavyDutyMachinery): string =>
  space.telemetry && isPublicMachineryTelemetry(space.telemetry) ? space.telemetry.status : 'Available';

export const toMachineryMapPin = (space: IHeavyDutyMachinery): IMapPin => ({
  id: space.id,
  latitude: space.latitude,
  longitude: space.longitude,
  priceLabel: `${Math.round(priceOf(space))}€`,
  liveStatus: liveStatusOf(space),
});
